export default __webpack_public_path__ + "static/media/rounded-corners.1f9bdcc5.webp";